import { useAutoneTranslation } from '@autone/translations';
import { forwardRef, useMemo } from 'react';

import { Button, type ButtonProps } from '../../atoms';
import { cn } from '../../utils';

type SelectAllToggleButtonProps = Omit<
  ButtonProps,
  'aria-label' | 'children' | 'size' | 'variant'
> & {
  allSelected: boolean;
  itemsCount: number;
};

export const SelectAllToggleButton = forwardRef<
  HTMLButtonElement,
  SelectAllToggleButtonProps
>(({ allSelected, itemsCount, className, ...props }, ref) => {
  const { common } = useAutoneTranslation();

  const label = useMemo(
    () =>
      allSelected
        ? common.withValue('dropdowns.clear-all', {
            value: itemsCount,
            count: itemsCount,
          })
        : common.withValue('dropdowns.select-all', {
            value: itemsCount,
            count: itemsCount,
          }),
    [allSelected, common, itemsCount],
  );

  return (
    <Button
      ref={ref}
      aria-label={label}
      size="sm"
      variant="outline"
      className={cn('font-normal', className)}
      {...props}
    >
      {label}
    </Button>
  );
});

SelectAllToggleButton.displayName = 'SelectAllToggleButton';
